import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { find, each } from 'lodash';

@Component({
  selector: 'gen-checkboxlist',
  templateUrl: './checkBoxList.component.html',
  styleUrls: ['checkBoxList.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CheckBoxListComponent implements OnInit {
  @Input() filter: any;
  isSelected: any;
  public isStatisticsPanel = true;

  constructor() {
  }

  ngOnInit() {
    if (this.filter.statistics) {
      this.filter.config.values = this.filter.statistics.values;
    }
  }
  updateSelection(event, id) {
    const checkbox = event.target;
    const action = (checkbox.checked ? 'add' : 'remove');
    this.updateSelected(action, id);
  }

  updateSelected(action, id) {

    const isExists = find(this.filter.selectedValue.value, (val) => {
      return val.id === id;
    });

    const normalizedIdValue = id !== undefined ? id : null;

    if (action === 'add' && !isExists) {
      this.filter.selectedValue.value.push({ id: normalizedIdValue});
    }

    if (action === 'remove' && isExists) {

      let index: any = -1;
      each(this.filter.selectedValue.value, (data, idx) => {
        if (data.id === normalizedIdValue) {
          index = idx;
          return;
        }
      });
      if (index > -1) {
        this.filter.selectedValue.value.splice(index, 1);
      }
    }
  }


}
